import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { getDefaultAccountManager } from '@mkp/shared/models';
import { AssetComponent } from '@mkp/shared/ui-asset';
import { AVATAR_DEFAULT_CONFIG, AvatarConfig, AvatarSize } from '@mkp/shared/ui-library';
import { getInfoEmail } from '@mkp/shared/util-environment';
import { DataTestDirective } from '@mkp/tracking/feature-tracking';

@Component({
  selector: 'ui-account-manager',
  imports: [AssetComponent, DataTestDirective],
  templateUrl: './account-manager.component.html',
  styleUrl: './account-manager.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountManagerComponent {
  showContact = input(true);

  protected readonly accountManager = getDefaultAccountManager(getInfoEmail());

  protected readonly avatarConfig: AvatarConfig = {
    ...AVATAR_DEFAULT_CONFIG,
    size: AvatarSize.Medium,
  };
}
